export const popupsArr = [
  { text: 'Кажется, в письмах есть отправленное хакером, надо разобраться.', buttonTitle: 'ПРОДОЛЖИТЬ' },
]
